// extracted by mini-css-extract-plugin
export default {"logo":"P82R_bCwlWwpXsUfI2rS"};